import React, { JSX } from "react";
import { twMerge } from "tailwind-merge";

interface AttributeProps {
  logo: string | JSX.Element;
  label: string;
  useWhiteBg?: boolean;
}

export function Attribute({ logo, label, useWhiteBg }: AttributeProps) {
  return (
    <span className="inline-flex h-5 items-center gap-1 rounded-l rounded-br border-0.5 border-neutral-200 px-1.5 text-xs uppercase tracking-[0.5px] text-neutral-900 group-hover:bg-primary-200">
      <span className="block overflow-hidden rounded-full">
        {typeof logo === "string" ? <img width={16} height={16} src={logo} alt={label} className={twMerge(useWhiteBg && "rounded-full bg-white")} /> : logo}
      </span>
      {label}
    </span>
  );
}
